// src/js/components/table-of-contents.js
var TableOfContents = class extends HTMLElement {
  /**
   * Constructor
   */
  constructor() {
    super();
    this.init();
  }
  /**
   * Init
   */
  init() {
    this.mainContent = document.getElementById("toc-main-content");
    let headings = this.mainContent.querySelectorAll("h2");
    if (headings.length < 1) {
      return;
    }
    if ("page" === this.dataset.contentType) {
      headings = Array.from(headings);
      headings.push(...this.getSiblingHeadings());
    }
    const tocList = this.querySelector("ul");
    headings.forEach((heading) => {
      const headingText = heading.innerText;
      const headingId = "toc-target-" + this.toAttribute(headingText);
      heading.setAttribute("id", headingId);
      tocList.appendChild(this.createListItem(headingId, headingText));
    });
    tocList.classList.remove("has-style-loading");
  }
  /**
   * Get Sibling Headings
   * 
   * @return {Array}
   */
  getSiblingHeadings() {
    const mainContentParent = this.mainContent.parentNode;
    let nextSibling = mainContentParent.nextElementSibling;
    let siblingHeadings = [];
    while (nextSibling) {
      siblingHeadings.push(...nextSibling.querySelectorAll("h2"));
      nextSibling = nextSibling.nextElementSibling;
    }
    return siblingHeadings;
  }
  /**
   * To Attribute
   * 
   * @param {String} text
   * 
   * @return {String}
   */
  toAttribute(text) {
    return text.replaceAll(" ", "-").replaceAll(/[^a-zA-Z0-9\-]/g, "").toLowerCase();
  }
  /**
   * Create List Item
   * 
   * @param {String} headingId
   * @param {String} headingText
   * 
   * @return {Element}
   */
  createListItem(headingId, headingText) {
    const tocListItem = document.createElement("li");
    const tocAnchor = document.createElement("a");
    tocAnchor.textContent = headingText;
    tocAnchor.setAttribute("href", "#" + headingId);
    tocListItem.appendChild(tocAnchor);
    return tocListItem;
  }
};
customElements.define("table-of-contents", TableOfContents);
